
import { Button } from '../../../components/base/Button';

export function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#254a29]/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#254a29]/15 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#254a29]/10 rounded-full blur-3xl animate-pulse delay-500"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        {/* Main Heading */}
        <div className="mb-8 animate-fade-in">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
            Professionelle
            <span className="block bg-gradient-to-r from-[#254a29] to-[#3d7a42] bg-clip-text text-transparent">
              Lösungen für Sichtbarkeit
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Hochwertige Beachflags, Fahnenmast-Flaggen und mehr für Ihren perfekten Markenauftritt
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-20 animate-fade-in-delay-1">
          <Button href="/produkte" size="lg" className="text-lg shadow-xl hover:shadow-2xl transform hover:scale-105">
            Produkte entdecken
          </Button>
          <Button 
            href="/kontakt" 
            variant="outline" 
            size="lg" 
            className="text-lg bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-[#254a29] shadow-xl"
          >
            Beratung anfragen
          </Button>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 animate-fade-in-delay-2">
          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-300 hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-br from-[#254a29] to-[#3d7a42] rounded-xl flex items-center justify-center mb-4 mx-auto">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Premium Qualität</h3>
            <p className="text-gray-300">Langlebige Materialien für dauerhaften Einsatz im Außenbereich</p>
          </div>

          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-300 hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-br from-[#254a29] to-[#3d7a42] rounded-xl flex items-center justify-center mb-4 mx-auto">
              <i className="ri-palette-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Individuelle Designs</h3>
            <p className="text-gray-300">Maßgeschneiderte Lösungen für Ihre Markenbotschaft</p>
          </div>

          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-300 hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-br from-[#254a29] to-[#3d7a42] rounded-xl flex items-center justify-center mb-4 mx-auto">
              <i className="ri-truck-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Schnelle Lieferung</h3>
            <p className="text-gray-300">Zuverlässige Produktion und pünktliche Auslieferung</p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto animate-fade-in-delay-3">
          <div className="text-center">
            <div className="text-4xl font-bold text-[#254a29] mb-2">500+</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">Zufriedene Kunden</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#254a29] mb-2">15+</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">Jahre Erfahrung</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#254a29] mb-2">10.000+</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">Produzierte Fahnen</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#254a29] mb-2">100%</div>
            <div className="text-gray-400 text-sm uppercase tracking-wider">Qualitätsgarantie</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 border-2 border-[#254a29] rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-[#254a29] rounded-full animate-scroll"></div>
        </div>
      </div>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes scroll {
          0% {
            transform: translateY(0);
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            transform: translateY(12px);
            opacity: 0;
          }
        }

        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }

        .animate-fade-in-delay-1 {
          animation: fade-in 1s ease-out 0.3s both;
        }

        .animate-fade-in-delay-2 {
          animation: fade-in 1s ease-out 0.6s both;
        }

        .animate-fade-in-delay-3 {
          animation: fade-in 1s ease-out 0.9s both;
        }

        .animate-scroll {
          animation: scroll 2s ease-in-out infinite;
        }

        .delay-500 {
          animation-delay: 0.5s;
        }

        .delay-1000 {
          animation-delay: 1s;
        }
      `}</style>
    </section>
  );
}
